import '!wix-tpa-style-loader?mode=inline!sass-loader?{"includePaths": [".", "node_modules"]}!../../assets/styles/injected-style-fullscreen.global.scss';
import '../../assets/styles/injected-style-fullscreen.global.scss';
import '../../assets/styles/index-fullscreen.scss';
